
if(jQuery(window).width()<769){
  jQuery(".tab_toggle .tab li").off("click").on("click",function(){
    jQuery(this)
    .addClass('active') // 返回 jQuery(this)
    .siblings() // 返回ul下li的兄弟
    .removeClass('active') // 返回ul下li的兄弟
    .parent() // 返回ul
    .next() // 返回ol
    .children() // 返回ol下所有li
    .eq(jQuery(this).index()) // 返回ol下的一个li
    .addClass('active') // 返回ol下的一个li
    .siblings() // 返回ol下li的兄弟
    .removeClass('active'); // 返回ol下li的兄弟
    if(jQuery('.tab_second').hasClass('active')){
      console.log('有选中啊');
      jQuery('.tab_toggle').css({"background-image":'url(https://cdn.shopifycdn.net/s/files/1/1720/3725/files/17282_2x_d580abeb-599a-4521-a5a9-ac94141057dc.png?v=1685944840)'})
    }
    if(jQuery('.tab_first').hasClass('active')){
      console.log('第一个有选中啊');
      jQuery('.tab_toggle').css({"background-image":'url(https://cdn.shopifycdn.net/s/files/1/1720/3725/files/17281_2x_66621555-e72c-415a-83c1-5df0cefc0285.png?v=1685944840)'})
    }
  })
}
if(jQuery(window).width()>768){
  if(window.location.href=="https://www.klaiyihair.com/pages/klaiyi-brand-day-promotion?show=account"){
    jQuery('.tab li').css('line-height','50px');
    jQuery('.content li p').css('margin-top','30px');
    jQuery('.tab_toggle').css('min-height','510px');
  }
  jQuery(".tab_toggle .tab li").off("click").on("click",function(){
    console.log('点击1111');
    jQuery(this)
    .addClass('active') // 返回 jQuery(this)
    .siblings() // 返回ul下li的兄弟
    .removeClass('active') // 返回ul下li的兄弟
    .parent() // 返回ul
    .next() // 返回ol
    .children() // 返回ol下所有li
    .eq(jQuery(this).index()) // 返回ol下的一个li
    .addClass('active') // 返回ol下的一个li
    .siblings() // 返回ol下li的兄弟
    .removeClass('active'); // 返回ol下li的兄弟
    if(jQuery('.tab_second').hasClass('active')){
      console.log('有选中啊');
      jQuery('.tab_toggle').css({"background-image":'url(https://cdn.shopify.com/s/files/1/1720/3725/files/17293.png?v=1685944345)'})
    }
    if(jQuery('.tab_first').hasClass('active')){
      console.log('第一个有选中啊');
      jQuery('.tab_toggle').css({"background-image":'url(https://cdn.shopify.com/s/files/1/1720/3725/files/17290_1.png?v=1685944345)'})
    }
  })
}
jQuery(window).resize(function(){
  if(jQuery(window).width()<769){
    jQuery(".tab_toggle .tab li").off("click").on("click",function(){
      jQuery(this)
      .addClass('active') // 返回 jQuery(this)
      .siblings() // 返回ul下li的兄弟
      .removeClass('active') // 返回ul下li的兄弟
      .parent() // 返回ul
      .next() // 返回ol
      .children() // 返回ol下所有li
      .eq(jQuery(this).index()) // 返回ol下的一个li
      .addClass('active') // 返回ol下的一个li
      .siblings() // 返回ol下li的兄弟
      .removeClass('active'); // 返回ol下li的兄弟
      if(jQuery('.tab_second').hasClass('active')){
        console.log('有选中啊');
        jQuery('.tab_toggle').css({"background-image":'url(https://cdn.shopifycdn.net/s/files/1/1720/3725/files/17282_2x_d580abeb-599a-4521-a5a9-ac94141057dc.png?v=1685944840)'})
      }
      if(jQuery('.tab_first').hasClass('active')){
        console.log('第一个有选中啊');
        jQuery('.tab_toggle').css({"background-image":'url(https://cdn.shopifycdn.net/s/files/1/1720/3725/files/17281_2x_66621555-e72c-415a-83c1-5df0cefc0285.png?v=1685944840)'})
      }
    })
  }
  if(jQuery(window).width()>768){
    jQuery(".tab_toggle .tab li").off("click").on("click",function(){
      jQuery(this)
      .addClass('active') // 返回 jQuery(this)
      .siblings() // 返回ul下li的兄弟
      .removeClass('active') // 返回ul下li的兄弟
      .parent() // 返回ul
      .next() // 返回ol
      .children() // 返回ol下所有li
      .eq(jQuery(this).index()) // 返回ol下的一个li
      .addClass('active') // 返回ol下的一个li
      .siblings() // 返回ol下li的兄弟
      .removeClass('active'); // 返回ol下li的兄弟
      if(jQuery('.tab_second').hasClass('active')){
        console.log('有选中啊');
        jQuery('.tab_toggle').css({"background-image":'url(https://cdn.shopify.com/s/files/1/1720/3725/files/17293.png?v=1685944345)'})
      }
      if(jQuery('.tab_first').hasClass('active')){
        console.log('第一个有选中啊');
        jQuery('.tab_toggle').css({"background-image":'url(https://cdn.shopify.com/s/files/1/1720/3725/files/17290_1.png?v=1685944345)'})
      }
    })
  }
})
  // 倒计时
  function getLocalTime(i) {
    if (typeof i !== 'number') return;
    var d = new Date();
    var len = d.getTime();
    var offset = d.getTimezoneOffset() * 60000;
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
  }
  
  window.getNextDate = function(date, day) {
    var dd = new Date(date);
    console.log(dd)
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "/" + m + "/" + d;
  }
  var timeZoneParams = -5;
  jQuery(function() {
      if (jQuery('.endsIn').length || jQuery('.memberFlash-timeBox').length) {
          var date = getLocalTime(timeZoneParams);
          var date_day = date.getDate();
          var date_month = date.getMonth() + 1;
          var date_year = date.getFullYear();
          var newendTime = getNextDate(date_year + '/' + date_month + '/' + date_day, 3);
          var newendAllTime = new Date(newendTime).getTime() - date;
  
          function newtimerMember(intDiff) {
              var hour = 0,
                  minute = 0,
                  second = 0;
              intDiff = intDiff - 0;
              if (intDiff > 0) {
                  hour = Math.floor(intDiff / 1000 / 60 / 60);
                  minute = Math.floor(intDiff / 1000 / 60 % 60);
                  second = Math.floor(intDiff / 1000 % 60);
              }
              if (hour < 10) {
                  hour = '0' + hour;
              }
              if (minute < 10) {
                  minute = '0' + minute;
              }
              if (second < 10) {
                  second = '0' + second;
              }
            
            jQuery('.branchDay-clock_timeH').text(hour);
            jQuery('.branchDay-clock_timeM').text(minute);
            jQuery('.branchDay-clock_timeS').text(second);

          }
          var groupTime = setInterval(function() {
              if (newendAllTime > 0) {
                newtimerMember(newendAllTime);
                newendAllTime -= 1000;
              } else {
                  date = getLocalTime(timeZoneParams);
                  date_day = date.getDate();
                  date_month = date.getMonth();
                  date_year = date.getFullYear();
                  newendTime = getNextDate(date_year + '/' + date_month + '/' + date_day);
                  newendAllTime = new Date(newendTime).getTime() - date;
              }
          }, 1000);
      }
  
  })
  
   
   
   
  
    // 倒计时结束